import { render, staticRenderFns } from "./Moving_Handling.vue?vue&type=template&id=3a10586e&"
import script from "./Moving_Handling.vue?vue&type=script&lang=js&"
export * from "./Moving_Handling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports